import React from 'react';
import classnames from 'classnames';

import SVGIcon from 'components/svg-icon/SVGIcon';

import { __t, applyTranslations } from 'utils/language';

applyTranslations(require('./signup-section.i18n.json'));

type Props = {
  children: React.ReactNode,
  type: 'influencer' | 'brand' | 'agency' | 'none'
};

export const SignUpSection = ({ children, type }: Props) => {
  const pricingUrl = 'https://www.collabary.com/pricing/';
  const arrowClasses = classnames({
    'signup-section__arrow': true,
    [`signup-section__arrow--${type}`]: type
  });

  const items = [
    {
      type: 'brand',
      link: pricingUrl,
      label: __t('signup_section.signup_brand'),
      icon: (
        <SVGIcon
          name="brand-type"
          width="100%"
          height="100%"
        />
      )
    },
    {
      type: 'influencer',
      link: '/signup/content-creator',
      label: __t('signup_section.signup_creator'),
      icon: (
        <SVGIcon
          name="creator-type"
          width="100%"
          height="100%"
        />
      )
    },
    {
      type: 'agency',
      link: pricingUrl,
      label: __t('signup_section.signup_agency'),
      icon: (
        <SVGIcon
          name="agency-type"
          width="100%"
          height="100%"
        />
      )
    }
  ];

  return (
    <section className="signup-section">
      <h1 className="signup-section__title">
        {__t('signup_section.signup_selection_title')}
      </h1>
      <div className="signup-section__type-container">
        {
          items.map((item) => {
            const itemClasses = classnames({
              'signup-section__type': true,
              'signup-section__type--active': item.type === type
            });

            const newTab = item.type === 'brand' || item.type === 'agency';
            const tabProps: React.HTMLProps<HTMLAnchorElement> = {};

            if (newTab) {
              tabProps.target = '_blank';
            }

            return (
              <a
                key={item.type}
                href={item.link}
                className={itemClasses}
                {...tabProps}
              >
                <span className="signup-section__type-icon">
                  {item.icon}
                </span>
                <span className="signup-section__type-name">
                  {item.label}
                </span>
              </a>
            );
          })
        }
      </div>
      {
        type !== 'none' &&
          <div>
            <div className={arrowClasses} />
            <div className="signup-section__content">
              {children}
            </div>
          </div>
      }
    </section>
  );
};

export default SignUpSection;
